(ns teamoesterreich.admin-mode.toe-map-search.small-toe-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent-material-ui.icons.edit :as ic-edit]
            [teamoesterreich.view-state :as vstate]

            [reagent.core :as r]
            [teamoesterreich.util.log :as log]))



(defn get-sort-filter-rows [elms sort_ reverse_ ]
  ;(js/console.log "get-sort-filter-rows elms  " elms)
  (let [rows (if elms (mapv (fn [[k v]] (assoc v :index k)) elms) [])
        rows (sort-by #(get % (if sort_ sort_ "lastName")) rows)
        rows (if reverse_ (reverse rows) rows)
        ]
    rows))


(defn edit-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label "bearbeiten"
                        :onClick #(swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] cell-data)
                        } [ic-edit/edit {:fontSize "small"}]])))


(defn select-me-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/checkbox
         {:onChange (fn [_ val] (swap! !st assoc-in [:selected  cell-data] val))
          :checked (get-in @!st [:selected cell-data])
          }
         ]))))


(defn number-cell-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        (let [selectedElm (:highLightToe @!st)]
          [:div {:style #js {:backgroundColor (if (= cell-data selectedElm) "#1919f0" "inherit")
                             :color (if (= cell-data selectedElm) "#ffffff" "inherit") }}
           [:button {:className "personNumberLink"
                     :style {:backgroundColor (if (= cell-data selectedElm) "#1919f0" "inherit")
                             :color (if (= cell-data selectedElm) "#ffffff" "inherit") }
                     ;:onDoubleClick (fn [] (swap! vstate/app-state assoc-in
                     ;                [:toe-map :activeUserPopup] cell-data
                     ;                [:toe-map :highLightToe] cell-data))
                     :title cell-data
                     } cell-data]])))))



(defn table [!st]
  (let [!sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:reverse])
        !elems (r/cursor !st [:elems])
        rows (get-sort-filter-rows @!elems @!sort @!reverse)
        ]

    (fn [m]
      (log/debug " width " (get (js->clj m) "width") )
      (r/as-element

              [:> rv/Table
               {:headerHeight 50
                :height 525
                :rowCount (count rows)
                :rowGetter (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
                :rowClassName (fn [i] (when (odd? (aget i "index")) "table-odd"))
                :sort (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))

                :sortBy (:sort @!st)
                :sortDirection (if (:reverse @!st) "DESC" "ASC")

                :onRowClick (fn [i]
                              ;(println (clj->js (nth rows (aget i "index"))))
                              (swap! !st assoc :highLightToe (:user-tomId (nth rows (aget i "index"))))


                              )
                :onRowDoubleClick (fn [i] (swap! vstate/app-state assoc-in
                                                 [:toe-map :activeUserPopup] (:user-tomId (nth rows (aget i "index")))
                                                 [:toe-map :highLightToe] (:user-tomId (nth rows (aget i "index")))))

                :rowHeight 45
                :width (or (get (js->clj m) "width") 400)
                :headerClassName "headerColumn"
                :className "MapToeListTable"}

               [:> rv/Column
                {:label (r/as-element [mui/checkbox {:clickable "false"}])
                 :dataKey (name :tomId)
                 :className "bordered exampleColumn"
                 :cellRenderer (select-me-renderer !st)
                 :width 70} [:a {:href ""}]]

               [:> rv/Column
                {:label "TomId"
                 :dataKey (name :tomId)
                 :className "bordered exampleColumn"
                 :style #js { :overflow "hidden" }
                 :cellRenderer (number-cell-renderer !st)
                 :width 70}]
               [:> rv/Column
                {:label "Vorname"
                 :dataKey (name :firstName)
                 :className "bordered exampleColumn"
                 :style #js { :overflow "hidden" }
                 :width 170}]
               [:> rv/Column
                {:label "Nachname"
                 :dataKey (name :lastName)
                 :className "bordered exampleColumn"
                 :width 170}]
               [:> rv/Column
                {:label        (r/as-element [ic-edit/edit])
                 :dataKey      "tomId"
                 :className    "bordered exampleColumn"
                 :cellRenderer edit-cell-renderer
                 :width        70} ]
               [:> rv/Column
                {:label "Distanz"
                 :dataKey (name :distance)
                 :className "bordered exampleColumn"
                 :width 90} [:a {:href ""}]]
               ]))))

(defn autoSizer-table [!st]
     [:> rv/AutoSizer
      {:style {:height "550px" :width "100%"}
       :sort (str "rerender !st" @!st)}
      (table !st)])
